import { combineReducers } from 'redux';
import { postReducer } from './postReducer';
import { transferReducer, orderTransferReducer, customersReducer, inventoryReducer, statusUpdateReducer } from './landingPageReducer';
import authReducer from './AuthReducer';
import showSideMenuReducer from './sideMenuReducer';
import chosenSidebarReducer from './sideMenuReducer';
import chosenDropdownMenuReducer from './dropdownMenuReducer';
import consignmentsPostReducer from './consignmentsPostReducer';
import errorHandlerReducer from './ErrorReducer';
import { AuthActionType } from '../actions/actionTypes';
import { adminReducer } from './AdminReducer';
import { invoicesReducer } from './invoicesReducer';
import { rotatesReducer } from './rotatesReducer';
import { returnsReducer } from './returnsReducer';


const allReducer = combineReducers({
    posts: postReducer,
    transfer: transferReducer,
    ordersTransferReducer: orderTransferReducer,
    customersReducer: customersReducer,
    inventory: inventoryReducer,
    statusUpdateReducer: statusUpdateReducer,
    authreducer: authReducer,
    showSideMenuReducer: showSideMenuReducer,
    chosenSidebar: chosenSidebarReducer,
    chosenDropdownMenuReducer: chosenDropdownMenuReducer,
    consignmentsPostReducer: consignmentsPostReducer,
    errorHandlerReducer: errorHandlerReducer,
    adminReducer: adminReducer,
    invoicesReducer: invoicesReducer,
    rotatesReducer: rotatesReducer,
    returnsReducer: returnsReducer,
});

// export default allReducer;
//https://stackoverflow.com/questions/35622588/how-to-reset-the-state-of-a-redux-store
export default (state, action) => allReducer(action.type === AuthActionType.LOGOUT_SUCCESS ? undefined : state, action);
